/**
 * Mixin para manejo de telemetría de uso de IA
 */
export default {
  data() {
    return {
      telemetry: null
    }
  },

  methods: {
    /**
     * Crea estructura inicial de telemetría
     * @param {Object} models - Diccionario de modelos { CLEAN: 'gemini-x', ... }
     */
    createInitialTelemetry(models = {}) {
      const rpm = {}
      Object.values(models).forEach(model => {
        rpm[model] = 0
      })

      return {
        usageMetadata: {
          RPM: rpm,
          candidatesTokenCount: 0,
          promptTokenCount: 0,
          thoughtsTokenCount: 0,
          totalTokenCount: 0
        }
      }
    },

    /**
     * Actualiza telemetría con nuevos datos de uso
     * @param {string} model - Modelo usado (opcional, para RPM)
     * @param {Object} usageMetadata - Metadata de uso de la respuesta
     */
    updateTelemetry(model, usageMetadata) {
      if (!this.telemetry) {
        console.warn('Telemetry not initialized')
        return
      }

      // Actualizar RPM si se proporciona modelo
      if (model && this.telemetry.usageMetadata.RPM) {
        if (!this.telemetry.usageMetadata.RPM[model]) {
          this.telemetry.usageMetadata.RPM[model] = 0
        }
        this.telemetry.usageMetadata.RPM[model]++
      }

      // Actualizar contadores
      this.telemetry.usageMetadata.candidatesTokenCount += usageMetadata.candidatesTokenCount || 0
      this.telemetry.usageMetadata.promptTokenCount += usageMetadata.promptTokenCount || 0
      this.telemetry.usageMetadata.totalTokenCount += usageMetadata.totalTokenCount || 0
      this.telemetry.usageMetadata.thoughtsTokenCount += usageMetadata.thoughtsTokenCount || 0
    },

    /**
     * Formatea telemetría para mostrar en JSON
     */
    formatTelemetry(data = this.telemetry.usageMetadata) {
      return JSON.stringify(data, null, 2)
    },

    /**
     * Resetea telemetría a valores iniciales
     */
    resetTelemetry() {
      if (this.telemetry) {
        const models = Object.keys(this.telemetry.usageMetadata.RPM || {})
        const modelDict = {}
        models.forEach(model => {
          modelDict[model] = model
        })
        this.telemetry = this.createInitialTelemetry(modelDict)
      }
    },

    /**
     * Calcula el costo en USD de la telemetría actual
     * Basado en los precios de Gemini 2.5 Flash
     * @returns {Object} - { total, input, output, formatted }
     */
    calculateAICost() {
      if (!this.telemetry || !this.telemetry.usageMetadata) {
        return {
          total: 0,
          input: 0,
          output: 0,
          formatted: '$0.000000'
        }
      }

      const metadata = this.telemetry.usageMetadata

      // Precios de Gemini 2.5 Flash (por 1M tokens)
      const PRICE_INPUT_PER_1M = 0.075 // Prompt + Thinking
      const PRICE_OUTPUT_PER_1M = 0.3 // Candidates

      // Calcular costos
      const inputTokens = (metadata.promptTokenCount || 0) + (metadata.thoughtsTokenCount || 0)
      const outputTokens = metadata.candidatesTokenCount || 0

      const inputCost = (inputTokens / 1000000) * PRICE_INPUT_PER_1M
      const outputCost = (outputTokens / 1000000) * PRICE_OUTPUT_PER_1M
      const totalCost = inputCost + outputCost

      return {
        total: totalCost,
        input: inputCost,
        output: outputCost,
        formatted: `$${totalCost.toFixed(6)}`,
        breakdown: {
          inputTokens,
          outputTokens,
          inputCost: `$${inputCost.toFixed(6)}`,
          outputCost: `$${outputCost.toFixed(6)}`
        }
      }
    }
  }
}
